type EventProperties = Record<string, unknown>;

function isEventProperties(value: unknown): value is EventProperties {
  return !!value && typeof value === "object" && !Array.isArray(value);
}

function hasIubendaConsent(): boolean {
  return document.cookie
    .split(";")
    .map((cookie) => cookie.trim())
    .includes("cookie_consent=given");
}

function parseEventProperties(eventProperties: string | null): EventProperties {
  try {
    const parsed = JSON.parse(eventProperties || "{}");
    return isEventProperties(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

export default function tracking(): void {
  const heapTrackables = document.querySelectorAll<HTMLElement>(
    "a[data-heap-event], button[data-heap-event]"
  );

  heapTrackables.forEach((trackable) => {
    if (trackable.dataset.heapTrackingBound) return;
    trackable.dataset.heapTrackingBound = "true";

    trackable.addEventListener("click", () => {
      const eventName = trackable.getAttribute("data-heap-event");
      const eventProperties = parseEventProperties(
        trackable.getAttribute("data-heap-event-properties")
      );

      const canTrack =
        eventName && typeof window.heap !== "undefined" && hasIubendaConsent();

      if (!canTrack) {
        return;
      }

      window.heap?.track(eventName, eventProperties);
    });
  });
}
